// TODO QS-10687: Replace with the official third-party logo when available.
/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioHelpjuiceIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-helpjuice-dev" */ './utils').then(
			(m) => m.ForgePioHelpjuiceIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/icon' },
);

const LazyForgePioHelpjuiceSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-helpjuice-dev-search-result" */ './utils').then(
			(m) => m.ForgePioHelpjuiceSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-helpjuice-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioHelpjuiceIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioHelpjuiceIconComponent />
	</Suspense>
);

export const ForgePioHelpjuiceSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioHelpjuiceSearchResultIconComponent />
	</Suspense>
);
